<app-accordion
	label="ترکیب دارایی پرتفوی"
	containerClass="mt-2"
	expandedMaxHeightClass="max-h-[1000px]"
	[(expanded)]="compositionExpanded">
	<section class="px-3" aria-label="ترکیب دارایی‌های پرتفوی" data-cy="portfolio-report-composition">
		<div class="relative flex justify-center py-3">
			<div class="size-44" data-cy="portfolio-report-composition-chart">
				<app-portfolio-composition-chart [ariaLabel]="chartAriaLabel()" [slices]="chartData()" />
			</div>
		</div>

		<div class="flex flex-col">
			@for (item of composition(); track item.label) {
				<div
					class="flex min-h-11 items-center justify-between gap-2 border-t border-gray-200 py-3 text-3.25"
					[attr.data-cy]="'portfolio-report-composition-item-' + $index">
					@if (item.symbolIsin) {
						<a
							class="flex min-w-0 items-center gap-1"
							[routerLink]="['/symbol-details', item.symbolIsin]"
							[attr.aria-label]="'نمایش جزئیات نماد ' + item.label">
							<span
								class="size-2 shrink-0 rounded-full"
								aria-hidden="true"
								[style.background]="item.color"></span>
							<span class="truncate font-bold text-gray-900">{{ item.label }}</span>
							<span class="shrink-0 text-gray-600">{{ item.percentage | number: '1.2-2' }}%</span>
							@if (item.isOther) {
								<span class="shrink-0 text-gray-600">({{ item.members.length }} نماد)</span>
							}
						</a>
					} @else {
						<div class="flex min-w-0 items-center gap-1">
							<span
								class="size-2 shrink-0 rounded-full"
								aria-hidden="true"
								[style.background]="item.color"></span>
							<span class="truncate font-bold text-gray-900">{{ item.label }}</span>
							<span class="shrink-0 text-gray-600">{{ item.percentage | number: '1.2-2' }}%</span>
							@if (item.isOther) {
								<span class="shrink-0 text-gray-600">({{ item.members.length }} نماد)</span>
							}
						</div>
					}
					<div class="flex shrink-0 items-center gap-0.5 text-gray-900">
						@if (amountsHidden()) {
							<span class="tracking-widest">{{ maskedValue() }}</span>
						} @else {
							<ui-number format="1.0-0" dir="ltr" class="tabular-nums" [value]="item.value" />
						}
						<span>ریالءء</span>
						@if (item.isOther) {
							<button
								type="button"
								class="flex size-8 items-center mr-2 justify-center rounded-lg bg-gray-050 text-gray-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-500"
								data-cy="portfolio-report-other-toggle"
								aria-controls="portfolio-report-composition-other-items"
								[attr.aria-expanded]="otherExpanded()"
								[attr.aria-label]="otherExpanded() ? 'بستن نمادهای سایر' : 'نمایش نمادهای سایر'"
								(click)="otherExpanded.update(expanded => !expanded)">
								<ui-icon
									width="18"
									height="18"
									aria-hidden="true"
									[iconName]="otherExpanded() ? 'chevron-up' : 'chevron-down'" />
							</button>
						}
					</div>
				</div>
				@if (item.isOther) {
					<div
						id="portfolio-report-composition-other-items"
						class="flex flex-col"
						role="region"
						aria-label="نمادهای سایر"
						[hidden]="!otherExpanded()">
						@for (member of item.members; track member.label) {
							<div
								class="flex min-h-11 items-center justify-between gap-2 border-t border-gray-200 py-3 text-3.25 mr-3"
								data-cy="portfolio-report-composition-other-item">
								@if (member.symbolIsin) {
									<a
										class="flex min-w-0 items-center gap-1"
										[routerLink]="['/symbol-details', member.symbolIsin]"
										[attr.aria-label]="'نمایش جزئیات نماد ' + member.label">
										<span
											class="size-2 shrink-0 rounded-full"
											aria-hidden="true"
											[style.background]="item.color"></span>
										<span class="truncate font-bold text-gray-900">{{ member.label }}</span>
										<span class="shrink-0 text-gray-600"
											>{{ member.percentage | number: '1.2-2' }}%</span
										>
									</a>
								} @else {
									<div class="flex min-w-0 items-center gap-1">
										<span
											class="size-2 shrink-0 rounded-full"
											aria-hidden="true"
											[style.background]="item.color"></span>
										<span class="truncate font-bold text-gray-900">{{ member.label }}</span>
										<span class="shrink-0 text-gray-600"
											>{{ member.percentage | number: '1.2-2' }}%</span
										>
									</div>
								}
								<div class="flex shrink-0 items-center gap-0.5 text-gray-900">
									@if (amountsHidden()) {
										<span class="tracking-widest">{{ maskedValue() }}</span>
									} @else {
										<ui-number
											format="1.0-0"
											dir="ltr"
											class="tabular-nums"
											[value]="member.value" />
									}
									<span>ریالءء</span>
								</div>
							</div>
						}
					</div>
				}
			}
		</div>
	</section>
</app-accordion>
